// extracted by css-extract-rspack-plugin
export default {"field":"CreateUser__field--pEUb2","footer":"CreateUser__footer--WskSk"};